module.exports = __webpack_public_path__ + "components/flag/static/square/gu-62911464231a710ec400fdb4f6342367.svg";